<template>
  <ml-table
    :columns="columns"
    :data-source="tableData"
    rowKey="id"
    :loading="tableLoading"
    :pagination="false"
    :canChangeColWidth="true"
  >
    <div slot="action" slot-scope="text, record" style="width: 190px;">
      <a-popconfirm
        :title="$t('page_transport_directory_sure_to_delete_the_file')"
        @confirm="handleAction(record, 'delete')"
        :okText="$t('ok')" :cancelText="$t('cancel')"
        v-if="canEdit"
      >
        <a class="del-color" v-acl="'page_transport_directory_delete'" @click.stop>{{$t('delete')}}</a>
      </a-popconfirm>
      <a-divider v-acl="'page_transport_directory_download'" type="vertical" v-if="canEdit"/>
      <a v-acl="'page_transport_directory_download'" @click.stop="handleAction(record, 'download')">{{$t('page_my_document_download')}}</a>
      <a-divider type="vertical"/>
      <a @click.stop="handleAction(record, 'preview')" :disabled="record.suffix==='zip'">{{$t('preview')}}</a>
    </div>
  </ml-table>
</template>

<script>
import { columns } from './data'

export default {
  name: 'FileList',
  props: {
    tableLoading: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: () => ([])
    },
    canEdit: { // 是否允许编辑：如删除
      type: Boolean,
      default: true
    }
  },
  data () {
    return {}
  },
  computed: {
    columns () {
      let newColumns = [
        {
          title: 'page_tenant_operation',
          key: 'action',
          width: 190,
          scopedSlots: { customRender: 'action' }
        }, ...columns
      ]
      return newColumns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    }
  },
  methods: {
    handleAction (record, type) {
      let params = {
        record,
        type
      }
      this.$emit('handleAction', params)
    }
  }
}
</script>
